<div class="leitor-side-menu-container">
  <div class="leitor-side-menu">
    <div class="leitor-side-menu-button">
      <app-button-leitor-side-menu
        (click)="btnBuscaClick()"
        [opcao]="buscaSelecao"
        [ativo]="painelBuscaAberto"
        [matTooltip]="buscaSelecao.descricao"
        matTooltipPosition="right"
      ></app-button-leitor-side-menu>

      <app-button-leitor-side-menu
        (click)="toggle(ferramentaSelecao)"
        [opcao]="ferramentaSelecao"
        [ativo]="
          opcaoSelecionada?.modo === ferramentaSelecao?.modo &&
          opcaoSelecionada?.tipo === ferramentaSelecao?.tipo
        "
        [matTooltip]="ferramentaSelecao.descricao"
        matTooltipPosition="right"
      ></app-button-leitor-side-menu>

      <app-button-leitor-side-menu
        (click)="toggle(ferramentaBorracha)"
        [opcao]="ferramentaBorracha"
        [ativo]="
          opcaoSelecionada?.modo === ferramentaBorracha?.modo &&
          opcaoSelecionada?.tipo === ferramentaBorracha?.tipo
        "
        [matTooltip]="ferramentaBorracha.descricao"
        matTooltipPosition="right"
      ></app-button-leitor-side-menu>
    </div>

    <mat-divider class="menu-divider"></mat-divider>

    <div class="leitor-side-menu-button-scrolling">
      <div *ngFor="let opcao of opcoesExibir" class="leitor-side-menu-button">
        <app-button-leitor-side-menu
          [opcao]="opcao"
          (toggleButtonLeitor)="toggle($event)"
          [ativo]="
            opcaoSelecionada?.modo === opcao.modo &&
            opcaoSelecionada?.tipo === opcao.tipo
          "
          [matTooltip]="opcao.descricao"
          matTooltipPosition="right"
        ></app-button-leitor-side-menu>
      </div>
    </div>
  </div>
</div>
